/**
 * 侧栏 menuId 分区 SSOT
 *
 * 规则（根治 menu 树漂移 · 2026-07-15）：
 * 1. Leo 二级文件夹（LEO_SIDEBAR_FOLDER_IDS）已入库 coffee_menu（patch 133）；
 *    侧栏与角色授权树只跟 parent_id，**禁止**常态 strip + buildLeoKnowledgeSidebarTree 重建。
 * 2. SYSTEM_SETTINGS_PLATFORM_MENU_IDS — 挂在 systemSetting 下，跟 nav API 树。
 * 3. buildLeoSidebarStripIdSet / 静态 rebuild 仅作「DB 尚未跑 133」时的临时兜底。
 *
 * @see scripts/mysql/menu_tree_ssot/leo_knowledge_folders.json（Overseas）
 * @see .cursor/rules/sidebar-content-ssot.mdc
 */

/** 侧栏五根（patch 283；与 portal_menu_tree.json 对齐） */
export const SIDEBAR_PILLAR_MENU_IDS = {
  systemSetting: 1721413907848888320,
  deviceXhm: 990501,
  socOps: 990502,
  memberFolder: 990503,
  leo: 990200,
  ecosystemMall: 990420
}

/** Leo 侧栏二级分组（patch 133 起入库，非虚拟） */
export const LEO_SIDEBAR_FOLDER_IDS = {
  portalOverview: 990276,
  modelKnowledge: 990277,
  ingestLoop: 990278,
  protocolTools: 990279,
  opsWorkbench: 990284,
  deviceIntel: 991009
}

/** systemSetting 下平台超管页（patch 077 / 092）；侧栏位置由 coffee_menu parent 决定 */
export const SYSTEM_SETTINGS_PLATFORM_MENU_IDS = {
  /** 後台視覺樣板（頁內 Tab 含樣板1/2/3；990510/990511 已併入，見 patch 294） */
  uiSurfaceSample: 990263,
  /** @deprecated patch 294 併入 990263 */
  uiSurfaceSample2: 990510,
  /** @deprecated patch 294 併入 990263 */
  uiSurfaceSample3: 990511,
  aiTrusteeAdmin: 990271,
  agentPermissionSteward: 990272,
  platformReleaseControl: 990340,
  /** patch 288 · SOC 用戶通知中心 */
  socNotificationCenter: 990512
}

/** 设备研发一级及其子项（patch 128；parent 对齐 scripts/mysql/menu_tree_ssot/device_rd_group.json） */
export const DEVICE_RD_SIDEBAR_MENU_IDS = {
  group: 990130,
  /** patch 310 · XHM AI 接手线源头；设备研发第1位 */
  equipmentDemands: 990439,
  machineDebug: 990220,
  simulatorGroup: 990105,
  /** coffee_menu 历史 id（非 990100） */
  deviceConfigGroup: 1721413909652439040,
  deviceLinkDebug: 990346,
  equipmentModelRepair: 990326,
  /** patch 186 · 三方 Partner OpenAPI 管理 */
  partnerApiAdmin: 990347,
  /** patch 188 · 配置档库／绑定与下发（与 router DEVICE_CONFIG_MENU_IDS 对齐） */
  configProfileLibrary: 990101,
  configBindDispatch: 990102,
  /** patch 450 · 出品分類／設備掛鉤／場景組合 */
  produceOutputCatalog: 991210
}

/** 库存管理（patch 115–123；990390 组，勿与 990380 售后冲突） */
export const STORE_MATERIAL_SIDEBAR_MENU_IDS = {
  group: 990390,
  stock: 990391,
  orders: 990392,
  consumable: 990393,
  mq: 990394,
  invoice: 990395,
  barcodeAlias: 990396,
  count: 990397,
  bomWizard: 990398,
  analytics: 990399,
  physicalMerge: 990400
}

/** 数据中心 · 萃茶机数据 · 物料损耗（patch 152；rename 162；原泡茶机物料，勿挂 990390） */
export const TEA_MACHINE_MATERIAL_SIDEBAR_MENU_IDS = {
  page: 990412
}

/** 数据中心 · 配料机数据 · 校准/满管（patch 369；parent 1776875108514795520） */
export const TEA_XT_SERIES_CALIB_FULLPIPE_SIDEBAR_MENU_IDS = {
  calibrationData: 991130,
  fullPipeData: 991131,
  parent: 1776875108514795520
}

/** 数据中心 · 萃茶机数据 · 单杯参数（patch 157；品质分析，不影响原单杯数据） */
export const TEA_SINGLE_CUP_PARAMS_SIDEBAR_MENU_IDS = {
  page: 990413
}

/** 数据中心 · 萃茶机数据 · 多机互联工作（patch 162） */
export const TEA_EARLY_BREW_WORK_SIDEBAR_MENU_IDS = {
  page: 990415
}

/** 数据中心 · 萃茶机数据 · 智能精度 E1（patch 201） */
export const TEA_E1_PERFORMANCE_SIDEBAR_MENU_IDS = {
  page: 990416
}

/** 数据中心 · 配料机数据 · 精準度／物料损耗／多机互联（挂 XTSeriesData；991132+，避开 990420 生态商城） */
export const DISPENSER_DATA_CENTER_SIDEBAR_MENU_IDS = {
  precision: 991132,
  materialLoss: 991133,
  multiMachine: 991134
}

/** 财务会计一级（patch 211；D6 正式会计三表） */
export const FINANCE_ACCOUNTING_SIDEBAR_MENU_IDS = {
  group: 990160,
  reports: 990161,
  view: 990162
}

/** 成本效率一级（patch 227；D9 独立闸） */
export const STORE_COST_OPTIMIZE_SIDEBAR_MENU_IDS = {
  group: 990163,
  desk: 990164,
  view: 990165,
  gate: 990166
}

/** 店铺 AI 自主营销一级（patch 228） */
export const STORE_AUTONOMOUS_MARKETING_SIDEBAR_MENU_IDS = {
  group: 990450,
  desk: 990451,
  view: 990452,
  gate: 990453
}

/** 運營總決策台（patch 229；D10） */
export const STORE_OPS_CEO_DESK_SIDEBAR_MENU_IDS = {
  group: 990167,
  desk: 990168,
  view: 990169,
  decide: 990454
}

/** B 層 AI 工程總控（patch 251） */
export const AI_ENGINEERING_CONTROL_SIDEBAR_MENU_IDS = {
  group: 990457,
  desk: 990458,
  view: 990459
}

/** 店務 P&L／現金（patch 255） */
export const STORE_PNL_SIDEBAR_MENU_IDS = {
  group: 990460,
  desk: 990461,
  view: 990462,
  gate: 990463
}

/** XHM 硬件伙伴（patch 256） */
export const XHM_HARDWARE_PARTNER_SIDEBAR_MENU_IDS = {
  group: 990464,
  desk: 990465,
  view: 990466,
  gate: 990467
}

/** XHM 三軌槽位（patch 260） */
export const XHM_FAMILY_SLOT_SIDEBAR_MENU_IDS = {
  group: 990468,
  desk: 990469,
  view: 990470,
  gate: 990471
}

/** 香港上市通道（patch 261；§1 未定案骨架） */
export const HK_MARKET_CHANNEL_SIDEBAR_MENU_IDS = {
  group: 990472,
  desk: 990473,
  signup: 990476,
  view: 990474,
  gate: 990475
}

/** 大陸上市通道（patch 268） */
export const CN_MARKET_CHANNEL_SIDEBAR_MENU_IDS = {
  group: 990485,
  desk: 990486,
  signup: 990489,
  view: 990487,
  gate: 990488
}

/** 餐廳桌碼點單（patch 444） */
export const DINE_TABLE_MENU_IDS = {
  desk: 990546
}

/** 品牌店付款綁定（patch 437） */
export const BRAND_STORE_PAYMENT_SIDEBAR_MENU_IDS = {
  group: 990540,
  bind: 990541,
  view: 990542,
  gate: 990543,
  listing: 990544,
  open: 990545,
  openAccount: 990547
}

/** 香港報稅工作台（patch 265；掛店務 P&L 組） */
export const HK_TAX_FILING_SIDEBAR_MENU_IDS = {
  desk: 990478,
  view: 990479,
  gate: 990480
}

/** 店鋪單據收件箱（patch 432；掛店務 P&L 組） */
export const STORE_RECEIPT_INBOX_SIDEBAR_MENU_IDS = {
  desk: 991150,
  view: 991151,
  gate: 991152
}

/** 門店首頁智能推薦戰役（patch 456） */
export const STORE_HOME_FEED_SIDEBAR_MENU_IDS = {
  desk: 991220,
  view: 991221,
  save: 991222
}

/** 商家区域 + 设备菜单（patch 427；写中心补挂） */
export const MERCHANT_REGION_MACHINE_MENU_IDS = {
  region: 990520,
  machineMenu: 990521
}

/** Leo Brand Agent 建店工作台（patch 267） */
export const LEO_BRAND_ONBOARDING_SIDEBAR_MENU_IDS = {
  group: 990481,
  desk: 990482,
  view: 990483,
  confirm: 990484
}

/** 排班出勤一级（patch 212；D7 零售周排班＋PIN 打卡） */
export const WORKFORCE_SIDEBAR_MENU_IDS = {
  group: 990170,
  weekSchedule: 990171,
  clock: 990172,
  summary: 990173,
  weekScheduleView: 990174,
  clockAction: 990175,
  summaryView: 990176,
  smartRoster: 990177,
  mySchedule: 990178,
  payroll: 990179,
  smartRosterRun: 990180,
  myScheduleView: 990181
}

/** 无人运营（patch 216；D8 决策例外） */
export const STORE_AUTOPILOT_SIDEBAR_MENU_IDS = {
  group: 990190,
  exceptions: 990191,
  exceptionsView: 990192
}

/** 生態商城一級（patch 168） */
export const ECOSYSTEM_MALL_SIDEBAR_MENU_IDS = {
  group: 990420,
  topology: 990421,
  catalog: 990422,
  synergyEdges: 990423,
  intents: 990424,
  vendors: 990425,
  mediaBilling: 990426,
  productSpecs: 990427,
  productionLines: 990428,
  search: 990429,
  mediaHub: 990430,
  productKnowledge: 990434,
  trialSim: 990435,
  businessPlans: 990436,
  websitePages: 990437,
  virtualWorkspace: 990438,
  equipmentDemands: 990439,
  socOps: 991082,
  portraits: 991084,
  immersivePromo: 991086,
  adOrchestrate: 991091,
  promoContent: 991097,
  channelCommand: 991139,
  bEndCrm: 991140,
  companyPay: 991088,
  priceBook: 991094,
  billingPromo: 991115,
  appDownloads: 991136
}

/** 店鋪選品一级（patch 226/231；獨立，≠ 生態商城） */
export const STORE_ASSORTMENT_SIDEBAR_MENU_IDS = {
  group: 990455,
  desk: 990443,
  view: 990444,
  gate: 990456
}

/** 出品 · X600H 配方中心（patch 124/125）；侧栏仅认 role_menu，禁止 device:edit 硬注入 */
export const X600H_RECIPE_CENTER_MENU_IDS = {
  coffeeMachineChannelSlots: 990401
}

/** 出品管理 · 通道配置（patch 187；勿用 990295） */
export const CHANNEL_CONFIG_UNDER_PRODUCT_CENTER_MENU_IDS = {
  group: 990431,
  channelCategory: 1730760166086938624,
  configDistribute: 1730775987551080448,
  devicesChannels: 1730779759245398016
}

/**
 * buildLeoKnowledgeSidebarTree / buildTrainingLakeSidebarTree 会静态回填的 menuId。
 * 新增 Leo 侧栏叶节点：先加此处 + builder，再加路由。
 */
export const LEO_SIDEBAR_REBUILD_MENU_IDS = {
  group: 990200,
  modelFields: 990241,
  upload: 990242,
  onboarding: 990243,
  capabilityMatrix: 990244,
  pipelineHub: 990245,
  featureSurface: 990246,
  protocolDoc: 990247,
  remoteTool: 990248,
  learning: 990249,
  externalIngest: 990250,
  ingestBatch: 990251,
  phase1Ssot: 990252,
  equipmentTypeTypeKey: 990253,
  testerConsole: 990254,
  deviceOpsRolePolicy: 990255,
  deviceOpsSemanticTraining: 990256,
  productionE2eTraining: 990266,
  turnRoutingTraining: 990267,
  trainingDashboard: 990268,
  t2GoldenTraining: 990269,
  t9DeepseekTraining: 990270,
  portalHub: 990257,
  portalOpsInventoryConsole: 990258,
  portalOpsDailyHub: 990259,
  deviceOpsReviewInbox: 990260,
  deviceOpsDescriptionAutogen: 990261,
  deviceOpsBLineDailyHub: 990262,
  commandOnboardingWizard: 990264,
  xeeGrowthDashboard: 990265,
  trainingFederationCases: 991001,
  trainingFederationCommandCenter: 991002,
  tasteHabitPerception: 991003,
  trainingDecisionDesk: 991004,
  trainingWorkBoard: 991137,
  aiSpendAudit: 991138,
  t7TasteMl: 991005,
  intelligenceGrowthDashboard: 991007,
  deviceOpsBundleCandidates: 991008,
  clawPlanCapabilityHub: 991006,
  e1Overview: 991010,
  e1Components: 991011,
  e1Proposals: 991012,
  e1Production: 991015,
  e1Health: 991016,
  e1Impact: 991017,
  e1Policy: 991018,
  e1TargetQuality: 991019,
  e1Curves: 991020,
  e1Peer: 991021,
  e1LifeGate: 991022,
  e2Formulas: 991023
}

/** 全球设备与认证 + 服务签约（Overseas patch 289/300/303/353） */
export const GLOBAL_DEVICE_BUS_MENU_IDS = {
  group: 991040,
  catalog: 991041,
  catalogApply: 991053,
  registry: 991042,
  legacyMigrate: 991043,
  issueSync: 991044,
  brandServiceContract: 991045,
  brandServiceContractSummary: 991051,
  brandServiceContractDesk: 991052,
  brandServiceModeA: 991066,
  brandServiceModeB: 991067,
  socLeoAddonOverview: 991072,
  socLeoAddonHomeList: 991073,
  socLeoAddonComList: 991074,
  socLeoAddonAiPack: 991075,
  /** Overseas patch 374 · 設備.XHM 主链引导 */
  orderLifecycleGuide: 991135,
  /** Overseas patch 480 · 設備.XHM 全球定位 */
  deviceGlobalMap: 991160
}

/** 订阅与账单 + 机端数据（Overseas patch 353） */
export const SUBSCRIPTION_BILLING_MENU_IDS = {
  folder: 991120,
  myPlan: 991121,
  deviceEndpointDataFolder: 991122,
  mallPricingCollectFolder: 991123
}

/** SOC／Leo 收费域夹（Overseas patch 303） */
export const MONETIZATION_DOMAIN_MENU_IDS = {
  socBasicOps: 991060,
  socStoreOpsPlus: 991061,
  socHqMulti: 991062,
  socPayIntegrate: 991063,
  socAnalytics: 991064,
  socSmartGuidePlus: 991065,
  socSmartGuideBrandDesk: 991076,
  leoBasic: 991068,
  leoHomeAddon: 991069,
  leoComAddon: 991070,
  leoAiPoints: 991071,
  leoAiPointsBillingEntry: 991077,
  opsAnalyticsDesk: 991078
}

/** @deprecated 已无「仅路由」Leo 页；保留空对象以免旧 import 崩 */
export const LEO_KNOWLEDGE_ROUTE_ONLY_MENU_IDS = {
}

/** 路由 meta.menuId 引用（Leo 域） */
export const LEO_KNOWLEDGE_MENU_IDS = Object.assign(
  {},
  LEO_SIDEBAR_REBUILD_MENU_IDS,
  LEO_KNOWLEDGE_ROUTE_ONLY_MENU_IDS
)

/** @returns {Set<number>} */
export function buildLeoSidebarStripIdSet () {
  const strip = new Set()
  Object.values(LEO_SIDEBAR_REBUILD_MENU_IDS).forEach((id) => {
    if (id != null) strip.add(Number(id))
  })
  Object.values(LEO_SIDEBAR_FOLDER_IDS).forEach((id) => {
    if (id != null) strip.add(Number(id))
  })
  Object.values(SYSTEM_SETTINGS_PLATFORM_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: SYSTEM_SETTINGS id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(DEVICE_RD_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: DEVICE_RD id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(STORE_MATERIAL_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: STORE_MATERIAL id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(TEA_SINGLE_CUP_PARAMS_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: TEA_SINGLE_CUP_PARAMS id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(TEA_MACHINE_MATERIAL_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: TEA_MACHINE_MATERIAL id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(TEA_EARLY_BREW_WORK_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: TEA_EARLY_BREW_WORK id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(TEA_E1_PERFORMANCE_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: TEA_E1_PERFORMANCE id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(DISPENSER_DATA_CENTER_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: DISPENSER_DATA_CENTER id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(ECOSYSTEM_MALL_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: ECOSYSTEM_MALL id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(FINANCE_ACCOUNTING_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: FINANCE_ACCOUNTING id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(STORE_COST_OPTIMIZE_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: STORE_COST_OPTIMIZE id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(STORE_AUTONOMOUS_MARKETING_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: STORE_AUTONOMOUS_MARKETING id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(STORE_OPS_CEO_DESK_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: STORE_OPS_CEO_DESK id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(AI_ENGINEERING_CONTROL_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: AI_ENGINEERING_CONTROL id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(STORE_PNL_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: STORE_PNL id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(XHM_FAMILY_SLOT_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: XHM_FAMILY_SLOT id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(HK_MARKET_CHANNEL_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: HK_MARKET_CHANNEL id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(CN_MARKET_CHANNEL_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: CN_MARKET_CHANNEL id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(BRAND_STORE_PAYMENT_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: BRAND_STORE_PAYMENT id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(HK_TAX_FILING_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: HK_TAX_FILING id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(STORE_RECEIPT_INBOX_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: STORE_RECEIPT_INBOX id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(STORE_HOME_FEED_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: STORE_HOME_FEED id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(LEO_BRAND_ONBOARDING_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: LEO_BRAND_ONBOARDING id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(XHM_HARDWARE_PARTNER_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: XHM_HARDWARE_PARTNER id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(GLOBAL_DEVICE_BUS_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: GLOBAL_DEVICE_BUS id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(STORE_ASSORTMENT_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: STORE_ASSORTMENT id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(WORKFORCE_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: WORKFORCE id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(STORE_AUTOPILOT_SIDEBAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: STORE_AUTOPILOT id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(MERCHANT_REGION_MACHINE_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: MERCHANT_REGION_MACHINE id ${id} must not appear in Leo strip set`
      )
    }
  })
  Object.values(SIDEBAR_PILLAR_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id)) && Number(id) !== LEO_SIDEBAR_REBUILD_MENU_IDS.group) {
      throw new Error(
        `sidebarMenuIdSsot: SIDEBAR_PILLAR id ${id} must not appear in Leo strip set (except Leo root)`
      )
    }
  })
  Object.values(LEO_KNOWLEDGE_ROUTE_ONLY_MENU_IDS).forEach((id) => {
    if (id != null && strip.has(Number(id))) {
      throw new Error(
        `sidebarMenuIdSsot: route-only id ${id} must not appear in Leo strip set until added to sidebar builder`
      )
    }
  })
  return strip
}

/** 单测：注册表分区互斥 */
export function assertSidebarMenuIdRegistry () {
  buildLeoSidebarStripIdSet()
  const sys = new Set(Object.values(SYSTEM_SETTINGS_PLATFORM_MENU_IDS).map(Number))
  const rebuild = new Set(Object.values(LEO_SIDEBAR_REBUILD_MENU_IDS).map(Number))
  for (const id of sys) {
    if (rebuild.has(id)) {
      throw new Error(`SYSTEM_SETTINGS id ${id} overlaps LEO_SIDEBAR_REBUILD_MENU_IDS`)
    }
  }
  return { strip: buildLeoSidebarStripIdSet(), systemSettings: sys, rebuild }
}



//////////////////
// WEBPACK FOOTER
// ./src/constants/sidebarMenuIdSsot.mjs
// module id = 6Xwt
// module chunks = 492